var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92009 10.4933C7.79342 10.4933 7.66675 10.4467 7.56675 10.3467L5.86009 8.64C5.66675 8.44666 5.66675 8.12666 5.86009 7.93333C6.05342 7.74 6.37342 7.74 6.56675 7.93333L7.92009 9.28666L9.27342 7.93333C9.46675 7.74 9.78676 7.74 9.98009 7.93333C10.1734 8.12666 10.1734 8.44666 9.98009 8.64L8.27342 10.3467C8.17342 10.4467 8.04675 10.4933 7.92009 10.4933Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91992 10.4467C7.64659 10.4467 7.41992 10.22 7.41992 9.94667V3.16667C7.41992 2.89334 7.64659 2.66667 7.91992 2.66667C8.19326 2.66667 8.41992 2.89334 8.41992 3.16667V9.94667C8.41992 10.22 8.19326 10.4467 7.91992 10.4467Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.4533C4.56675 14.4533 2.16675 12.0533 2.16675 8.62C2.16675 8.34666 2.39341 8.12 2.66675 8.12C2.94008 8.12 3.16675 8.34666 3.16675 8.62C3.16675 11.4667 5.15341 13.4533 8.00008 13.4533C10.8467 13.4533 12.8334 11.4667 12.8334 8.62C12.8334 8.34666 13.0601 8.12 13.3334 8.12C13.6067 8.12 13.8334 8.34666 13.8334 8.62C13.8334 12.0533 11.4334 14.4533 8.00008 14.4533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.7cef91378e818b1c475210973148af4e.svg";
export { ForwardRef as ReactComponent };